export default "\n\n<ion-nav\n#nav\n></ion-nav>";